import React from 'react';
import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';

const plans = [
  {
    name: 'Gel Glow',
    price: '$55',
    badge: 'Most Popular',
    tagline: 'Unlimited 7–14 day gel sets',
    features: [
      'Unlimited UV-cure gel sets',
      'Patent-pending 7–14 day hold',
      'AI 3D nail art on every visit',
      'Mobile service — we come to you',
      'Priority same-day booking',
      'Free shaping & cuticle care',
    ],
    cta: 'Subscribe to Gel Glow',
    accent: 'amber',
    testid: 'gel',
  },
  {
    name: 'Acrylic Glow',
    price: '$75',
    badge: 'Best Value',
    tagline: 'Full acrylic + unlimited fill-ins',
    features: [
      'Full acrylic set every month',
      'Unlimited monthly fill-ins',
      'AI 3D nail art on every visit',
      'Mobile service — we come to you',
      'VIP priority booking',
      'Free shaping & cuticle care',
    ],
    cta: 'Subscribe to Acrylic Glow',
    accent: 'pink',
    testid: 'acrylic',
  },
  {
    name: 'VIP Total Glow',
    price: '$149',
    badge: 'Ultimate',
    tagline: 'Nails + spray tan + facial each month',
    features: [
      'Everything in Acrylic Glow',
      '1 luxury spray tan per month',
      '1 signature facial per month',
      'Exclusive priority scheduling',
      'Birthday gift box',
      '$25 Nail Cash bonus monthly',
    ],
    cta: 'Subscribe to VIP',
    accent: 'gold',
    testid: 'vip',
  },
];

const Plans = () => {
  return (
    <div className="py-20" data-testid="plans-page">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="text-[10px] tracking-[0.35em] uppercase text-amber-300/70 mb-4">✦ Subscriptions ✦</div>
          <h1 className="font-serif text-5xl sm:text-6xl text-amber-50" data-testid="plans-title">
            Pick your <span className="italic text-pink-300">glow level</span>
          </h1>
          <p className="mt-4 text-amber-100/60 max-w-2xl mx-auto">
            All plans include mobile service, our patent-pending 3D AI nail printer, and access to your private client portal. Cancel anytime.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {plans.map(p => (
            <div
              key={p.name}
              className="relative rounded-2xl bg-[#0a0405] border border-amber-900/30 p-8 hover:border-pink-400/30 hover:shadow-2xl hover:shadow-amber-500/10 transition-all"
              data-testid={`plan-${p.testid}`}
            >
              <div className="text-[10px] tracking-[0.3em] uppercase text-amber-300/70">{p.badge}</div>
              <div className="font-serif text-3xl text-amber-100 mt-2">{p.name}</div>
              <div className="text-sm text-amber-100/60 italic mt-1">{p.tagline}</div>

              <div className="mt-6 flex items-baseline gap-1">
                <span className="font-serif text-5xl text-amber-50">{p.price}</span>
                <span className="text-amber-100/60">/ month</span>
              </div>

              <ul className="mt-8 space-y-3 text-sm text-amber-100/80">
                {p.features.map(f => (
                  <li key={f} className="flex items-start gap-2">
                    <Check className="w-4 h-4 text-pink-300 mt-0.5 flex-shrink-0" />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>

              <Link
                to="/book"
                className="mt-8 block text-center py-3 rounded-full bg-pink-300 text-black font-medium hover:bg-pink-200 transition-all"
                data-testid={`plan-cta-${p.testid}`}
              >
                {p.cta}
              </Link>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center max-w-2xl mx-auto">
          <p className="text-amber-100/60 text-sm">
            Not ready to commit? <Link to="/book" className="text-pink-300 underline" data-testid="plans-onetime-link">Book a one-time service</Link> instead. Pricing is à la carte and varies by service — call <a href="tel:9046729966" className="text-amber-200">904.672.9966</a> for a custom quote.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Plans;
